import ProjectContainer from './containers/ProjectContainer'

export default ProjectContainer
